<template>
  <!--  pc端首页-->
  <div>
    <Header></Header>
    <router-view/>
    <Footer/>
  </div>
</template>
<script>
import Header from '../views/pc/header/header'
import Footer from '../views/pc/footer/footer'
export default {
  components: {
    Header,
    Footer
  }
}
</script>



// WEBPACK FOOTER //
// src/views/pcPage.vue